import React, { Component } from 'react';

const withModalHandle = () => WrappedComponent => {
  class ComponentWithModal extends Component {
    constructor() {
      super();
      this.state = {
        isModalOpen: false
      };
    }

    handleOpen = e => {
      e && e.preventDefault();
      this.setState({
        isModalOpen: true
      });
    };

    handleClose = e => {
      e && e.preventDefault();
      this.setState({
        isModalOpen: false
      });
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          handleModalOpen={this.handleOpen}
          handleModalClose={this.handleClose}
          isModalOpen={this.state.isModalOpen}
        />
      );
    }
  }
  return ComponentWithModal;
};

export default withModalHandle;
